<template>
  <slot></slot>
  <modal :id="modalId" :modal-class="classes" :title="data.title">
    <p class="text-center">{{ data.message }}</p>
    <template #footer>
      <form :action="formAction" method="post">
        <slot name="form-method"></slot>
        <button type="button" class="btn btn-default m-r-sm" @click="onCancel"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button :type="submitForm ? 'submit' : 'button'" class="btn btn-primary text-uppercase" :class="confirmButtonClass" @click="onConfirm"><i class="fa fa-fw fa-check-square"></i> {{ this.confirmButtonText }}</button>
      </form>
    </template>
  </modal>
  <slot name="hidden"></slot>
</template>

<script>
import HasModal from "./mixins/HasModal";

/**
 * Input properties:
 *
 * modalId - custom id for modal component
 * classes - custom classes array or string for modal form
 * title - title for dialog
 * message - message for dialog body
 * confirmButtonClass - class of confirmation button
 * confirmButtonText - text of confirmation button
 *
 *
 * Emits:
 *
 * confirm - on Ok button click
 * cancel - on Cancel button click
 *
 * Usage examples:
 *
 * <simple-confirmation-modal
 *  title="Delete Items"
 *  :message="Are you sure?"
 *  @confirm="onConfirm"
 *  @cancel="onCancel">
 *   <a href="#" class="btn btn-danger" v-modal="'confirmation-modal'">
 *     <i class="fa fa-trash"/>
 *   </a>
 * </simple-confirmation-modal>
 *
 */
export default {
  mixins: [HasModal],

  emits: ['confirm', 'cancel'],

  props: {
    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'confirmation-modal'
    },
    // Custom classes array or string for modal form.
    classes: {
      type: [String, Array],
      default: ''
    },
    // Title for dialog.
    title: {
      type: String,
      default: ''
    },
    // Message for dialog body.
    message: {
      type: String,
      default: ''
    },
    // Class of confirmation button.
    confirmButtonClass: {
      type: [String, Array],
      default: 'btn-primary'
    },
    // Text of confirmation button.
    confirmButtonText: {
      type: String,
      default: 'Ok'
    },

    // Form action
    formAction: {
      type: String,
      default: ''
    },

    // Submit form
    submitForm: {
      type: Boolean,
      default: false
    },

  },

  data() {
    return {
      data: {
        title: this.title,
        message: this.message
      }
    };
  },

  watch: {
    // Watch on title props change.
    title: function (newVal) {
      this.data.title = newVal;
    },
    // Watch on message props change.
    message: function (newVal) {
      this.data.message = newVal;
    },
  },

  methods: {
    onConfirm() {
      this.$emit('confirm');
      if (!this.submitForm) {
        this.hideModal();
      }
    },

    onCancel() {
      this.$emit('cancel');
      this.hideModal();
    },
  }
}
</script>
